export default [
  {
    path: 'shiftManage',
    component: () => import(/* webpackChunkName: "shift-manage" */ '@/pages/scheduling/ShiftManage'),
    meta: { title: '班次管理', cate: '排班打卡' }
  },
  {
    path: 'attendanceClockRecord',
    component: () => import(/* webpackChunkName: "attendance-clock-record" */ '@/pages/scheduling/AttendanceClockRecord'),
    meta: { title: '打卡记录', cate: '排班打卡' }
  },
  {
    path: 'attendanceClockStats',
    name: 'AttendanceClockStats',
    component: () => import(/* webpackChunkName: "attendance-clock-stats" */ '@/pages/scheduling/AttendanceClockStats'),
    meta: { title: '打卡统计', cate: '排班打卡' }
  }
]
